import React from 'react'
import { Link } from "gatsby"
import { Container } from "react-bootstrap"

function Sublinks() {
  return (
    <section className="sublinks">
      <Container>
        <div className="row py-3">
          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link
              to="/ladowarki"
              title="Poznaj parametry techniczne ładowarek">
              <figure>
                <span className="icon-icon-visual-1"></span>
              </figure>
              <div className="title">NASZE ŁADOWARKI</div>
            </Link>
          </div>

          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link
              to="/instrukcja-ladowania"
              title="instrukcja-ladowania">
              <figure>
                <span className="icon-icon-visual-2"></span>
              </figure>
              <div className="title">INSTRUKCJA ŁADOWANIA</div>
            </Link>
          </div>

          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link
              to="/regulamin"
              title="Zapoznaj się z regulaminem usługi ładowania">
              <figure>
                <span className="icon-icon-visual-3"></span>
              </figure>
              <div className="title">REGULAMIN USŁUG ŁADOWANIA</div>
            </Link>
          </div>

        </div>
      </Container>
    </section>
  )
}

export default Sublinks
